<div class="title">{{ question.getQuestion() | translate }}</div>
<div class="description">{{ question.getLabel() + ".description" | translate }}</div>